import { TowerAction, TowerServiceStatus } from '@/types/device'

export const OPTIMISTIC_STATUS_TIMEOUT_MS = 15000

const OPTIMISTIC_STATUS_BY_ACTION: Partial<
  Record<TowerAction, TowerServiceStatus>
> = {
  deploy: 'preparing',
  update: 'preparing'
}

export const optimisticStatusForAction = (action: TowerAction) => {
  return OPTIMISTIC_STATUS_BY_ACTION[action] ?? null
}

export const shouldClearOptimisticStatus = (
  reported: TowerServiceStatus,
  reportedWhenSet: TowerServiceStatus
) => {
  return reported !== reportedWhenSet
}
